import { useEffect, useState } from 'react';
import { getAllTicketAnswers } from '../../../services/sTicket/ticket.service';

const useGetTicketAnswers = (ticketAnswers, setTicketAnswers, ticket_id) => {
    

    useEffect(() => {
        const fetchTicketAnswers = async () => {
            try {
                const serviceResponse = await getAllTicketAnswers(ticket_id);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    const ticketAnswersData = response.data.map(element => ({
                        id: element.id,
                        subject: element.subject,
                        creation_date: element.creation_date,
                        has_docs: element.has_docs
                    }));
                    setTicketAnswers(ticketAnswersData);
                }
            } catch (error) {
                console.error('Error fetching ticket answers:', error);
            }
        };

        fetchTicketAnswers();

    }, [ticketAnswers, setTicketAnswers,ticket_id]);

    
};

export {
    useGetTicketAnswers    
};